import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'timeFormatter'})
export class TimeFormatterPipe implements PipeTransform {

  transform(value: string) {
    return value.split("T")[1].split("+")[0];
  }
}
